import Vue from 'vue'
import Router from 'vue-router'

import PayBack from './views/some/payBack' // 支付之后的辅助跳转页面
import ImagesPage from './views/some/imagesPage'
import Result from './views/some/result'
import EtcH5 from './views/some/etcH5.vue'
// 广西 H5
import CardUpdate from './views/some/cardUpdate'

// 新卡申办主流程
import VerifyPhone from './views/newApply/verifyPhone'
import GoodsDetail from './views/newApply/goodsDetail' // 仅招行进入
import GoodsDetailV2 from './views/newApply/goodsDetailV2'
import GoodsAddress from './views/newApply/goodsAddress'
import GoodsPay from './views/newApply/goodsPay'
import ChooseBank from './views/newApply/chooseBank'
import ApplyDetail from './views/newApply/applyDetail'
import OrderInfo from './views/newApply/orderInfo'
import UploadIDCard from './views/newApply/uploadIDCard'
import UploadVehicle from './views/newApply/uploadVehicle'
import UploadCredentials from './views/newApply/uploadCredentials'
import ApplyProgress from './views/newApply/applyProgress'

// 新卡申办业务辅助页面
import PaySuccess from './views/apply/paySuccess'
import BindSuccess from './views/apply/bindSuccess'
import Agreement from './views/apply/agreement'
import QA from './views/apply/QA'
import AllCommends from './views/apply/AllCommends'
import OptionBank from './views/apply/optionBank'
import ApplyQA from './views/apply/applyQA'
import CancelOrder from './views/apply/cancelOrder'

// 招行
import BindMM from './views/zhaohang/bindMM'
import PayDeposit from './views/zhaohang/payDeposit'
import AboutMM from './views/zhaohang/aboutMM'
import ThroughTecZH from './views/zhaohang/throughRec_zh'

import Center from './views/user/center'
// 平安好车主
// import ThroughRec from './views/pahcz/throughRec'

// --------------- PAKD
import ActiveSuccess from './views/pakd/activeSuccess'
import GoETC from './views/pakd/goETC'

// ---------------- 货车
import Register from './views/truck/register.vue'
import TruckDetail from './views/truck/truckDetail.vue'
// ---------------- 售后
import AfterSale from './views/afterSale/afterSale.vue'
Vue.use(Router)

const router = new Router({
  // mode: 'hash',
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      redirect: '/goodsDetail'
    },
    {
      path: '/home',
      name: 'home',
      meta: {
        title: 'ETC助手'
        // navigateStyle: {
        //   'background-color': '#0DE2A4',
        //   'color': 'white'
        // }
      },
      component: GoodsDetailV2
    },
    {
      path: '/payBack',
      name: 'payBack',
      meta: {
        title: 'ETC助手'
      },
      component: PayBack
    },
    {
      path: '/agreement',
      name: 'agreement',
      meta: {
        title: 'ETC助手'
      },
      component: Agreement
      // component: () => import('./views/some/agreement')
    },
    {
      path: '/qa', // 传参
      name: 'qa',
      meta: {
        title: '了解更多',
        navigateStyle: {
          'background-color': '#001d2c',
          color: 'white'
        }
      },
      component: QA
    },
    // ------------------------------------------------- new apply ------------------------------------
    {
      path: '/goodsDetail',
      name: 'goodsDetail',
      meta: {
        title: 'ETC助手'
        // keepPosition: true
      },
      beforeEnter: (to, form, next) => {
        console.log(to)
        if (
          to.name === 'goodsDetail' &&
          ['pahcz', 'zhaohang', 'zuizhuhai'].includes(to.query.channel)
        ) {
          // next({
          //   name: 'goodsDetailV1',
          //   query: to.query,
          //   params: to.params
          // })
          router.replace({
            name: 'goodsDetailV1',
            query: to.query,
            params: to.params
          })
        } else { next() }
      },
      component: GoodsDetailV2
      // component: () => import('./views/apply/cardList')
    },
    {
      path: '/goodsDetail_v1',
      name: 'goodsDetailV1',
      meta: {
        title: 'ETC助手'
      },
      component: GoodsDetail
    },
    {
      path: '/verify-phone',
      name: 'verifyPhone',
      meta: {
        title: 'ETC助手'
        // keepPosition: true
      },
      component: VerifyPhone
      // component: () => import('./views/apply/cardList')
    },
    {
      path: '/goodsAddress',
      name: 'goodsAddress',
      meta: {
        title: '填写资料'
        // keepPosition: true
      },
      component: GoodsAddress
      // component: () => import('./views/apply/cardList')
    },
    {
      path: '/chooseBank',
      name: 'chooseBank',
      meta: {
        title: '绑定银行卡'
        // keepPosition: true
      },
      component: ChooseBank
      // component: () => import('./views/apply/cardList')
    },
    {
      path: '/optionBank',
      name: 'optionBank',
      meta: {
        title: '意见收集'
        // keepPosition: true
      },
      component: OptionBank
      // component: () => import('./views/apply/cardList')
    },
    {
      path: '/result',
      name: 'result',
      meta: {
        title: '意见收集'
        // keepPosition: true
      },
      component: Result
      // component: () => import('./views/apply/cardList')
    },
    {
      path: '/applyDetail',
      name: 'applyDetail',
      meta: {
        title: '办理详情'
        // keepPosition: true
      },
      component: ApplyDetail
      // component: () => import('./views/apply/cardList')
    },
    {
      path: '/allCommends',
      name: 'allCommends',
      meta: {
        title: '精选评论'
      },
      component: AllCommends
      // component: () => import('./views/apply/cardList')
    },
    {
      path: '/applyQA',
      name: 'applyQA',
      meta: {
        title: '问答'
      },
      component: ApplyQA
      // component: () => import('./views/apply/cardList')
    },
    {
      path: '/goodsPay',
      name: 'goodsPay',
      meta: {
        title: '开通权益卡'
      },
      component: GoodsPay
      // component: () => import('./views/apply/cardList')
    },
    {
      path: '/orderInfo', // 订单信息
      name: 'orderInfo',
      meta: {
        title: 'ETC办理'
      },
      component: OrderInfo
      // component: () => import('./views/apply/cardList')
    },
    {
      path: '/uploadIDCard', // 上传身份证
      name: 'uploadIDCard',
      meta: {
        title: 'ETC办理'
      },
      component: UploadIDCard
      // component: () => import('./views/apply/cardList')
    },
    {
      path: '/uploadVehicle',
      name: 'uploadVehicle',
      meta: {
        title: 'ETC办理'
      },
      component: UploadVehicle
      // component: () => import('./views/apply/cardList')
    },
    {
      path: '/uploadCredentials',
      name: 'uploadCredentials',
      meta: {
        title: '上传证件'
      },
      component: UploadCredentials
      // component: () => import('./views/apply/cardList')
    },
    {
      path: '/cancelOrder',
      name: 'cancelOrder',
      meta: {
        title: '取消订单'
      },
      component: CancelOrder
      // component: () => import('./views/apply/cardList')
    },
    // ---------------------------------------------- 平安好车主 ------------------------------------------------
    // {
    //   path: '/throughRec',
    //   name: 'throughRec',
    //   meta: {
    //     title: 'ETC助手'
    //     // keepPosition: true
    //   },
    //   props: true,
    //   component: ThroughRec
    //   // component: () => import('./views/apply/cardList')
    // },
    // ---------------------------------------------- 平安口袋 ------------------------------------------------
    {
      path: '/activeSuccess',
      name: 'activeSuccess',
      meta: {
        title: '办理进度'
        // keepPosition: true
      },
      component: ActiveSuccess
      // component: () => import('./views/apply/cardList')
    },
    {
      path: '/goETC',
      name: 'goETC',
      meta: {
        title: '如何前往ETC'
        // keepPosition: true
      },
      component: GoETC
      // component: () => import('./views/apply/cardList')
    },
    // ---------------------------------------------- 招行 ------------------------------------------------
    {
      path: '/bindMM',
      name: 'bindMM',
      meta: {
        title: 'ETC会员'
        // keepPosition: true
      },
      component: BindMM
      // component: () => import('./views/apply/cardList')
    },
    {
      path: '/payDeposit', // 招行支付押金
      name: 'payDeposit',
      meta: {
        title: 'ETC会员'
        // keepPosition: true
      },
      component: PayDeposit
    },
    {
      path: '/aboutMM', // 招行关于免密支付
      name: 'aboutMM',
      meta: {
        title: '一网通免密支付'
        // keepPosition: true
      },
      component: AboutMM
    },
    {
      path: '/throughRec_zh', // 招行通行记录-还款
      name: 'throughRec_zh',
      meta: {
        title: '通行记录'
      },
      component: ThroughTecZH
    },
    // ----------------------------------------------------------------------------------------------------
    {
      path: '/paySuccess',
      name: 'paySuccess',
      meta: {
        title: '开通免密'
      },
      props: true,
      component: PaySuccess
    },
    {
      path: '/bindSuccess',
      name: 'bindSuccess',
      meta: {
        title: '申请成功'
      },
      component: BindSuccess
    },
    {
      path: '/applyProgress',
      name: 'applyProgress',
      meta: {
        title: '办理进度'
      },
      component: ApplyProgress
    },
    {
      path: '/center',
      name: 'center',
      meta: {
        title: '个人中心'
      },
      component: Center
    },
    {
      path: '/etcH5',
      name: 'etcH5',
      meta: {
        title: 'ETC助手'
      },
      component: EtcH5
      // component: () => import('./views/apply/cancelApply')
    },
    {
      path: '/c', // 尽量短的链接 广西 H5
      name: 'cardUpdate',
      meta: {
        title: '广西储值卡升级'
      },
      component: CardUpdate
      // component: () => import('./views/apply/cancelApply')
    },
    {
      path: '/imagesPage',
      name: 'imagesPage',
      meta: {
        title: 'ETC助手'
      },
      props: true,
      component: ImagesPage
      // component: () => import('./views/apply/cancelApply')
    },
    {
      path: '*',
      redirect: '/'
    },
    {
      path: '/goodsDetail/:uid/:channel/:issuer',
      name: 'goodsDetail',
      meta: {
        title: 'ETC助手'
        // keepPosition: true
      },
      component: GoodsDetailV2
      // component: () => import('./views/apply/cardList')
    },
    {
      path: '/truck',
      name: 'register',
      meta: {
        title: 'ETC货车'
        // keepPosition: true
      },
      component: Register
    },
    {
      path: '/truckDetail',
      name: 'register',
      meta: {
        title: ''
        // keepPosition: true
      },
      component: TruckDetail
    },
    {
      path: '/afterSale',
      name: 'afterSale',
      meta: {
        title: '客服中心'
        // keepPosition: true
      },
      component: AfterSale
    }
  ]
})

router.beforeEach((to, form, next) => {
  // 改变页面title
  if (to.meta.title) {
    document.title = to.meta.title
  }
  next() // 必须调用next()
})

export default router
